<template>
    <div class="layer shareUs">
        <div class="card">
            <button title="Close window" @click="closeTheWindowShare"><i class="fas fa-plus"></i></button>
            <h2> مشاركة </h2>
            <br>
            <nav>
                <a target="_blank"
                    href="https://twitter.com/intent/tweet?text=موقع%20صلاتي%20لأوقات%20الصلاة%20%20%20https://salatie.netlify.app"
                    class="post-twitter-alt" title="Post on twitter"><i class="fab fa-twitter"></i></a>

                <a target="_blank"
                    href="https://telegram.me/share/url?url=موقع%20صلاتي%20لأوقات%20الصلاة%20%20%20https://salatie.netlify.app"
                    class="share-telegram-alt" title="Share on telegram"><i class="fab fa-telegram-plane"></i></a>

                <a target="_blank"
                    href="https://api.whatsapp.com/send?text=موقع%20صلاتي%20لأوقات%20الصلاة%20%20%20https://salatie.netlify.app"
                    class="share-wa-alt" title="share on whatsapp"><i class="fab fa-whatsapp"></i></a>

                <a target="_blank" href="https://m.facebook.com/sharer.php?u=https://salatie.netlify.com"
                    class="share-fb-alt" title="share on facebook"><i class="fab fa-facebook-square"></i></a>

                <a class="copy-class" @click="shareUsCopy();" title="Copy"><i class="fa fa-share-alt fa-xs"></i></a>

                <a class="copy-class" @click="moreShare();" title="more share"><i class="far fas fa-ellipsis-h fa-xs"></i></a>
                <input style="position: absolute;width:0px;height:0px; z-index: -10;" id="linkHolder" value="موقع صلاتي لمعرفة أوقات الصلوات و المناسبات الإسلامية و الأذكار اليومية و قراءة القران              https://ltskurage.000webhostapp.com/salaty/">
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        closeTheWindowShare() {this.$emit("closeShare", false);},
        
        // other ways to copy
        moreShare() {
            //check share API support
            if (navigator.share) {
                navigator.share({
                    title: 'موقع صلاتي',
                    text: 'موقع صلاتي لمعرفة أوقات الصلوات و المناسبات الإسلامية و الأذكار اليومية و قراءة القران',
                    url: location.href
                }).then(() => {
                    this.copyMethod("شكرا على مشاكتك الموقع !");
                }).catch(console.error);
            }
            // check clipboard support
            else if (navigator.clipboard) {
                var copyText = window.linkHolder;
                copyText.select();
                copyText.setSelectionRange(0, 99999);
                navigator.clipboard.writeText(copyText.value);
                this.copyMethod(" تم نسخ الرابط إلى الحافظة ");
            }
            else {
                try {
                    var txtArea = document.createElement("textarea");
                    txtArea.width = "1px";
                    txtArea.height = "1px";
                    txtArea.background = "transparent";
                    //txtArea.className = "txtAr",    no needed
                    txtArea.value = "موقع صلاتي لأوقات الصلاة و الأدكار" + "\n" + location.href;
                    // txtArea.value = "موقع صلاتي لمعرفة أوقات الصلوات و المناسبات الإسلامية و الأذكار اليومية و قراءة القران" + "\n" + location.href;
                    document.body.append(txtArea);
                    txtArea.select();
                    document.execCommand("copy");
                    document.body.removeChild(txtArea);
                    this.copyMethod("تم نسخ النص إلى الحافظة");
                } catch (error) {
                    console.log(error);
                    alert("المتصفح الذي تستخدمه لا يدعم  خاصية المشاركة, يمكنك نسخ الرابط من شريط البحث");
                }
            }
        },
        // copy the link
        shareUsCopy() {
            var data = "لا تنسى زيارة موقعنا للمزيد من الأذكار" + "   \n" + location.href;
            var txtArea = document.createElement("textarea");
            txtArea.width = "1px";
            txtArea.height = "1px";
            txtArea.background = "transparent";
            txtArea.value = data;
            document.body.append(txtArea);
            txtArea.select();
            document.execCommand("copy");
            document.body.removeChild(txtArea);

            document.querySelector(".settings .layer.shareUs .card button").click();
            this.copyMethod("تم نسخ النص إلى الحافظة");
        },
        copyMethod(text) {
           // alert("hello world" + text);
            var tthx = document.querySelector(".thx");
            tthx.innerText = text;
            tthx.style.opacity = 1;
            tthx.style.top = "10%";
            setTimeout(function () {
                tthx.style.opacity = 0;
                tthx.style.top = "5%";
            }, 2000);
        }
    }
} 
</script>